module.exports = __webpack_public_path__ + "img/sb.795fa7c5.jpg";